import { createContext } from "react";

const stationsContext = createContext();

export default stationsContext;